import "bootstrap/dist/css/bootstrap.min.css";
import GridBoard from "./components/GridBoard";
import Header from "./components/Header";
import "./App.css";
import extensionsApi from './apis/extensionsApi';
import { useEffect, useState } from 'react';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import MainPage from "./components/MainPage";
import LoginPage from "./components/LoginPage";
import manageLoginSession from './utils/CustomizedSessionByTabs';

function App() {

//   const [listGroups, setListGroups] = useState([]);
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [listGroupCheckedOld, setListGroupCheckedOld] = useState([]);
//   const [listGroupChecked, setListGroupChecked] = useState([]);
//   const [loaded, setLoaded] = useState(false);

//   useEffect(() => {
    
//     const retrieveAllGroupName = (lsExtensions) => {
//         let groups = [];

//         for(let ii = 0; ii< lsExtensions.length; ii++) {
//             for(let jj = 0; jj < lsExtensions[ii].groupName.length; jj++) {
//                 if(!groups.includes(lsExtensions[ii].groupName[jj])) {
//                     groups.push(lsExtensions[ii].groupName[jj]);
//                 }
//             }
//         }

//         console.log("Groups are: ", groups);

//         setListGroups(groups);
//         setListGroupChecked(groups);

//         return groups;
//     }

//     const fetchExtensions = async () => {
//         try {
//             const response = await extensionsApi.getAll();

//             // console.log("Fetch extensions successfully: ", response);

//             // setListExtensions(response);

//             retrieveAllGroupName(response);

//             setLoaded(true);
//         } catch (error) {
//             // console.log("Failed to fetch extensions: ", error);
//         }
//     }


//     fetchExtensions();

//     // const interval = setInterval(() => {
//     //     fetchExtensions();
//     // }, 2000);

//     // return () => clearInterval(interval);
//   }, []);

//   const genCheckBox = () => {
//     const items = [];
//     for(let i = 0; i < listGroups.length; i++) {
//         items.push(
//             <FormGroup
//                 key={i}
//                 check
//             // inline
//             >
//                 <Input
//                     type="checkbox"
//                     value={listGroups[i]}
//                     defaultChecked={listGroupChecked.includes(listGroups[i])}
//                     // checked={isCheckAll & listGroupChecked.includes(listGroups[i])}
//                     // defaultChecked={true}
//                     onChange={(e) => {
//                         // alert(e.target.checked);

//                         // if(listGroupCheckedTmp.length === 0) {
//                         //   setListGroupCheckedTmp(listGroupChecked);
//                         // }
//                         const vv = [...listGroupChecked];

//                         if(e.target.checked) {
//                             if(!vv.includes(e.target.value)) {
//                                 vv.push(e.target.value)
//                                 setListGroupChecked(vv);
//                                 // setIsCheckAll(true);
//                             }
//                         } else {
//                             if(vv.includes(e.target.value)) {
//                                 setListGroupChecked(vv.filter(ez => ez !== e.target.value));
//                             }
//                         }
//                     }}
//                 />
//                 <Label check>
//                     {listGroups[i]}
//                 </Label>
//             </FormGroup>
//         )
//     }

//     return items;
// }

//   return (
//     <div className="App">
//       <Header />

//       <div className='d-flex justify-content-end'>
//                 <Button className='justify-content-end'
//                     color='primary'
//                     outline
//                     onClick={() => {
//                         setListGroupCheckedOld(listGroupChecked);
//                         setModalIsOpen(!modalIsOpen);
//                     }}
//                 >
//                     Choose Group
//                 </Button>
//             </div>
//             <Modal
//                 isOpen={modalIsOpen}
//             >
//                 <ModalHeader>
//                     Chọn Groups
//                 </ModalHeader>
//                 <ModalBody>
//                     <Form>
//                         {/* <FormGroup
//                             check
//                             // inline
//                         >
//                             <Input type="checkbox" />
//                             <Label check>
//                                 Some input
//                             </Label>
//                         </FormGroup>
//                         <FormGroup
//                             check
//                             // inline
//                         >
//                             <Input type="checkbox" 
//                                 onChange={(e) => {
//                                     alert(e.target.checked)
//                                 }}
//                             />
//                             <Label check>
//                                 Some other input
//                             </Label>
//                         </FormGroup> */}
//                         {/* <FormGroup
//                             check
//                             // inline
//                         >
//                             <Input
//                                 type="checkbox"
//                                 defaultChecked={true}
//                                 // value={isCheckAll}
//                                 onChange={(e) => {
//                                     if(e.target.checked) {
//                                         setListGroupChecked(listGroups);
//                                         setIsCheckAll(true);
//                                     } else {
//                                         setListGroupChecked([]);
//                                         setIsCheckAll(false);
//                                     }
//                                 }}
//                             />
//                             <Label check>
//                                 {listGroupChecked.length === listGroups.length ? 'Uncheck all' : 'Check all'}
//                             </Label>
//                         </FormGroup>
//                         <hr/> */}

//                         {loaded ? genCheckBox() : ''}
//                     </Form>
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button
//                         color='primary'
//                         onClick={() => {
//                             setModalIsOpen(!modalIsOpen);
//                             // alert(listGroupChecked);
                            
//                             // setListGroupChecked(listGroupCheckedTmp);
//                             // setListGroupCheckedTmp([]);
//                             // setCurrDataMatchGroupsSelected(listExtensions);
//                             console.log("HHH: ", listGroupChecked);
//                         }}
//                     >
//                         OK
//                     </Button>
//                     <Button
//                         onClick={() => {
//                             setModalIsOpen(!modalIsOpen);
//                             // console.log("HHH2: ", listGroupChecked);
//                             // setListGroupCheckedTmp([]);
//                             setListGroupChecked(listGroupCheckedOld);
//                             console.log("HHH2: ", listGroupChecked);
//                         }}
//                     >
//                         Cancel
//                     </Button>
//                 </ModalFooter>
//             </Modal>
//             <hr/>

//       {loaded ? <GridBoard lsGrSelected={listGroupChecked}/> : ''}
//     </div>
//   );

     const tokenIsExisted = localStorage.getItem("token") !== null;
    //const tokenIsExisted = sessionStorage.getItem("token") !== null;

    const [reloadToggle, setReloadToggle] = useState(tokenIsExisted);

    const receiveReloadToggle = (val) => {
        setReloadToggle(val);
    };

    manageLoginSession();

    return(
        <div>
            {reloadToggle ? <MainPage onHandleChange={receiveReloadToggle} /> :
            <LoginPage onHandleChange={receiveReloadToggle} />}
        </div>
    );
}

export default App;
